import { useEffect, useState } from 'react';
import questionpng from "./question.png"
import closepng from "./close.png"


import Chart from "chart.js/auto";
import { Line } from 'react-chartjs-2';
import zoomPlugin from 'chartjs-plugin-zoom';
Chart.register(zoomPlugin);

function App() {  


  const [type, setType] = useState("value")
  const [val, setVal] = useState(1)
  const [min, setMin] = useState(1)
  const [max, setMax] = useState(7)

  const [dataset, setDataset] = useState([])
  const [dataset2, setDataset2] = useState([])

  const [question, setQuestion] = useState(false)



  function findLst(nb) {
    if (nb <= 0) return [0]
    let lst = []
    
    for (let i = 0; i < 1000; i++) {
    
    lst.push(nb)
    
    if (nb % 2 === 0) {
      nb = nb / 2;
      
    } else {
      nb = 3* nb + 1
      
    }
  
    if (nb === 1) {
      lst.push(1)
      return lst
    }
  }

  return lst

}



  useEffect(() => { 
    if (val === "") {
      return [0]
    }else if (val <= 0) {
      setVal(1)
    }
    setDataset(findLst(Number(val)))

  }, [val])

  useEffect(() => {
    if (Number(max) > Number(min)+50) setMax(Number(min)+50)


    var list = [];
    for (var i = Number(min); i <= Number(max); i++) {
      list.push(i);
}
    let allDatasets = list.map((elt) => findLst(elt))


    let bestLenght = 0

    for (let i in allDatasets) {
      if (allDatasets[i].length > bestLenght) bestLenght = allDatasets[i].length
    }



    let data2 = {
      labels: [...Array(bestLenght).keys()],
  datasets: [
  ],
  }

  for (let i in allDatasets) {
    data2.datasets.push({
      label: String(allDatasets[i][0]),
      data: allDatasets[i],
      borderWidth: 3,
      borderColor: `rgba(${50 + Math.floor(Math.random() * 200)}, ${50 + Math.floor(Math.random() * 200)}, ${50 + Math.floor(Math.random() * 200)}, 0.5)`,
      backgroundColor: 'rgba(00, 90, 90, 0.2)',
    })
  }


    setDataset2(data2)

  }, [min, max])


  const options = {
    maintainAspectRatio: false,
    tension: .2,
    legend: {
      display: false
   },

    plugins: {
      zoom: {
        zoom: {
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true
          },
          mode: 'x',
          drag: {
            enabled: true
          },
          pan: {
            enabled: true,
            modifierKey: "ctrl"

          }
        }
      }
    }
  }

  const data = {
    labels: [...Array(dataset.length).keys()],
datasets: [
{
  label: '3x+1',
  data: dataset,
  borderWidth: 5,
  borderColor: 'rgb(00, 150, 150)',
  backgroundColor: 'rgba(00, 90, 90, 0.5)',
}
],
}


  return (
    <>
      <div className="flex">
        <div className='type'>
          <h1 className='up'>Type:</h1>
        
          <div className='up'>
            <div>
              <label htmlFor='val'>Value</label>
              <input type="radio" id='val' checked={type === "value" ? true : false} onClick={() => setType("value")}/>
            </div>
        
            <div>
              <label htmlFor='range'>Range</label>
              <input type="radio" id="range" checked={type === "value" ? false : true} onClick={() => setType("range")}/>
            </div>
          </div>
        </div>
        
            {type === "value" && <div className='val'>
          <input type="number" placeholder='value' value={val} onChange={(e)=>setVal(e.target.value)}/>
          <button onClick={()=>setVal(Number(val)+1)}>+</button>
          <button onClick={()=> val > 1 ? setVal(Number(val)-1) : null}>-</button>
            </div>}
      
      
    {type !== "value" && <div className='val'>
      <input type="number" placeholder='min' value={min} onChange={(e)=>{setMin(e.target.value); setMax(Number(e.target.value)+5)}}/>
      <input type="number" placeholder='max' value={max} onChange={(e)=>setMax(e.target.value)}/>
    </div>}

    </div>
    
      {type === "value" && <div className='line'><Line options={options} data={data} /></div>}
      {type !== "value" && <div className='line'><Line options={options} data={dataset2}/></div>}

    <img class="question" src={questionpng} alt="question mark" onClick={() => setQuestion(true)}/>
    {question && <Backdrop close={()=>setQuestion(false)}><Info close={()=>setQuestion(false)}/></Backdrop>}
    </>
  );
}

export default App;


function Info(props) {
  return (
    // <div className='info'>
    <div className="info_wid">
      <img className="close" src={closepng} alt="close" onClick={props.close} />
      <h2 className='collatz_name'>The Collatz conjecture</h2>
      <h3 className='collatz_text'>
        The Collatz conjecture concerns sequences of integers in which each term is obtained from
        the previous term as follows: 
        - If the previous term is even, the next
        term is one half of the previous term.
        - If the previous term is odd, the
        next term is 3 times the previous term plus 1.
        The conjecture is that
        these sequences always reach 1, no matter which positive integer is
        chosen to start the sequence.
      </h3>
      <h1 className="💜">
        Made with 💜 by{" "}
        <a href="https://github.com/bahAilime" target="_blank" className="link">
          Émilia B
        </a>
      </h1>


      <div className="usefull">
        <h2>Using</h2>
        <ul>
          <li>
            <a href="https://reactjs.org/">React</a> v17.0.2
          </li>
          <li>
            <a href="https://www.chartjs.org/">Chart.js</a> 3.5
          </li>
          <ul>
            <li>
              <a href="https://github.com/reactchartjs/react-chartjs-2">
                react-chartjs-2
              </a>{" "}
              v4.0.1
            </li>
            <li>
              <a href="https://www.chartjs.org/chartjs-plugin-zoom/latest/">
                chartjs-plugin-zoom
              </a>{" "}
              1.2.0
            </li>
          </ul>
          <li>
            Icons from <a href="https://icones8.fr/">icones8.fr</a>
          </li>
        </ul>
      </div>
    </div>
    // </div>
  );
}

function Backdrop(props) {
  return (
    <div className='back' onClick={props.close}>{props.children}</div>
  )
}